module.exports = __webpack_public_path__ + "static/img/meeting_4.9af41e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/meeting_4.jpg
// module id = BDt5
// module chunks = 3